
import { Observer } from 'mobx-vue'
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'

@Observer
@Component({
  components: {}
})
export default class SummaryHeader extends Vue {
  @Ref()
  audio: {
    play: () => void
    pause: () => void
  }

  isPlay: boolean = false

  // 开始学习时间
  get startTime() {
    return Number(this.PageStore.basicData?.startStudyTime)
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  get Global() {
    return this.$store.$global
  }

  // 音乐播放操作
  handlePlay() {
    if (!this.isPlay) {
      this.audio.play()
    } else {
      this.audio.pause()
    }
    this.isPlay = !this.isPlay
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
